import { z } from "zod";

export const serverResponse = z.object({
  status: z
    .enum([
      "waitsForAdminConfirmation",
      "accepted",
      "failed",
      "finished",
      "rejected",
    ])
    .optional(),
  orderId: z.string().optional(),
});
